
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppError } from '@/components';
import { usePicwordMapEdit } from '@/modules/picword/map/model/edit';
import { SelectableBooster } from '@/modules/picword/map/model/mixins';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';

export default defineComponent({
    name: ROUTE_NAME_PICWORD.MAP.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppError },
    setup() {
        const { model, v$, fetch, actions } = usePicwordMapEdit();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions, SelectableBooster };
    }
});
